import { render } from "./BaseCard.vue?vue&type=template&id=1d6606c4&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=1d6606c4&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6606c4"]])

export default __exports__